import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { getCurrency, fmtMoney } from "../lib/currency";

// Seed products (PHP base prices). Actual store products are merged in at runtime.
export const PRODUCTS = [
  { img: "/tumbler.jpg", name: "Artwork Tumbler", raised: 87450, goal: 150000, backers: 1240, percent: 58.3, price_usd: 2, price_php: 100 },
  { img: "/prod-wearable.jpg", name: "Wearable Art Tote", raised: 42120, goal: 90000, backers: 764, percent: 46.8, price_usd: 27, price_php: 1500 },
  { img: "/prod-decor.jpg", name: "Painted Vase", raised: 25980, goal: 60000, backers: 512, percent: 43.3, price_usd: 18, price_php: 1000 },
  { img: "/prod-furniture.jpg", name: "Accent Stool", raised: 61340, goal: 120000, backers: 903, percent: 51.1, price_usd: 45, price_php: 2500 },
];

// Live store products + campaign placeholder, currency-aware.
export const useCampaignProducts = () => {
  const [items, setItems] = useState(PRODUCTS);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/products`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        const store = (d?.products || [])
          .filter((p) => (p.price_php || p.price_usd))
          .map((p) => ({
            img: p.images?.[0] || "/tumbler.jpg",
            name: p.title,
            price_usd: p.price_usd || 0,
            price_php: p.price_php || 0,
          }));
        if (store.length > 0) setItems([...PRODUCTS, ...store]);
      })
      .catch(() => {});
  }, []);
  return items;
};

export const priceText = (p) => {
  const { code, symbol } = getCurrency();
  const val = code === "php" ? p.price_php : p.price_usd;
  return val > 0 ? fmtMoney(symbol, val) : null;
};

export const ProductStack = ({ index = 0, className = "h-16 w-16", products = PRODUCTS }) => (
  <div className={`relative shrink-0 ${className}`} data-testid="campaign-product-stack">
    <div className="absolute inset-0 rounded-xl bg-white/10 translate-x-2 translate-y-1 rotate-6" />
    <div className="absolute inset-0 rounded-xl bg-white/10 translate-x-1 translate-y-0.5 rotate-3" />
    <AnimatePresence mode="popLayout">
      <motion.img
        key={index}
        src={products[index].img}
        alt={products[index].name}
        data-testid="campaign-product-img"
        initial={{ x: 34, opacity: 0, rotate: 8 }}
        animate={{ x: 0, opacity: 1, rotate: 0 }}
        exit={{ x: -34, opacity: 0, rotate: -8 }}
        transition={{ duration: 0.55, ease: [0.76, 0, 0.24, 1] }}
        className="absolute inset-0 h-full w-full rounded-xl object-cover border border-white/15 shadow-lg"
      />
    </AnimatePresence>
  </div>
);
